import { deleteMessageOffline } from '../../messageInput/messageInputActions/deleteMessageOffline';
import { getMessage } from '../messageSelector';

const deleteMessage =
  ({ messageId }) =>
  async (dispatch, getState) => {
    const { channelId, index: messageIndex } = getMessage(messageId)(getState());
    dispatch(deleteMessageOffline({ channelId, messageIndex, messageId }));
  };

export default deleteMessage;
